/**
 *  Copyright (c) 2022-present TVM Engineering Authors.
 *
 */

import types from '../actions/types';
// import { ROLES } from '../config';

const INITIAL_STATE = {
	uploads: []
};

export default function uploadsReducer(state = INITIAL_STATE, action) {
	switch (action.type) {
		case types.GET_ALL_UPLOADS:
			return { ...state, uploads: action.payload };
		default:
			return state;
	}
}

// Selectors
export const getUploads = (state) => {
	return state.uploads.uploads;
}

